export default __webpack_public_path__ + "static/media/Mi_Colab.0dad2f76.svg";